import React, { useState } from 'react';
import {
    BudgetProposalWithResourcesT,
    CellRendererParams,
} from 'routes/BudgetModule/config/types';
import { IconButton, styled } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UpdateIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditCustomCadrageModal from './EditCustomCadrageModal';
import DeleteCustomCadrageModal from './DeleteCustomCadrageModal';
import {
    trackEventAddCustomCadrage,
    trackEventEditCustomCadrage,
} from './helper';

const StyIconButton = styled(IconButton, {
    name: 'StyIconButton',
})(({ theme }) => ({
    margin: '2px',
    color: theme.palette.primary.main,
}));

export default function ActionsCellRenderer({
    value: budgetProposal,
}: CellRendererParams<BudgetProposalWithResourcesT>): React.ReactElement | null {
    const [isEditCustomCadrageModalOpen, setIsEditCustomCadrageModalOpen] =
        useState(false);
    const [isDeleteCustomCadrageModalOpen, setIsDeleteCustomCadrageModalOpen] =
        useState(false);

    const [currentTrackEvent, setCurrentTrackEvent] = useState<
        ((budgetProposalName: string) => void) | null
    >(null);

    const onClickAdd = () => {
        setCurrentTrackEvent(() => trackEventAddCustomCadrage);
        setIsEditCustomCadrageModalOpen(true);
    };

    const onClickEdit = () => {
        setCurrentTrackEvent(() => trackEventEditCustomCadrage);
        setIsEditCustomCadrageModalOpen(true);
    };

    const onClickDelete = () => {
        setIsDeleteCustomCadrageModalOpen(true);
    };

    if (!budgetProposal) return null;
    return (
        <>
            {budgetProposal.hasCustomCadrage ? (
                <>
                    <StyIconButton size="small" onClick={onClickEdit}>
                        <UpdateIcon />
                    </StyIconButton>
                    <StyIconButton size="small" onClick={onClickDelete}>
                        <DeleteIcon />
                    </StyIconButton>
                </>
            ) : (
                <StyIconButton size="small" onClick={onClickAdd}>
                    <AddCircleIcon />
                </StyIconButton>
            )}
            {isEditCustomCadrageModalOpen && currentTrackEvent && (
                <EditCustomCadrageModal
                    isModalShown={isEditCustomCadrageModalOpen}
                    setShowModal={setIsEditCustomCadrageModalOpen}
                    budgetProposal={budgetProposal}
                    trackEvent={currentTrackEvent}
                />
            )}
            {isDeleteCustomCadrageModalOpen && (
                <DeleteCustomCadrageModal
                    isModalShown={isDeleteCustomCadrageModalOpen}
                    setShowModal={setIsDeleteCustomCadrageModalOpen}
                    budgetProposal={budgetProposal}
                />
            )}
        </>
    );
}
